"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogTrigger, Modal, ModalOverlay } from "@components/application/modals/modal";
import { Button } from "@components/base/buttons/button";
import type { ButtonProps } from "@components/base/buttons/button";
import { CloseButton } from "@components/base/buttons/close-button";
import { PlayCircle } from "@untitledui/icons";
import dynamic from "next/dynamic";
const DemoMuxPlayer = dynamic(() => import("@/components/shared-assets/mux-player/demo-mux-player").then(m => m.DemoMuxPlayer), {
  ssr: false
});
interface WatchDemoButtonProps extends Omit<ButtonProps, "iconLeading" | "children"> {
  size?: ButtonProps["size"];
  color?: ButtonProps["color"];
}
export function WatchDemoButton(t0) {
  const $ = _c(11);
  let buttonProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      size: t1,
      color: t2,
      ...buttonProps
    } = t0);
    $[0] = t0;
    $[1] = buttonProps;
    $[2] = t1;
    $[3] = t2;
  } else {
    buttonProps = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const size = t1 === undefined ? "xl" : t1;
  const color = t2 === undefined ? "secondary" : t2;
  let t3;
  if ($[4] !== buttonProps || $[5] !== color || $[6] !== size) {
    t3 = <Button color={color} size={size} iconLeading={PlayCircle} {...buttonProps}>Watch a Demo</Button>;
    $[4] = buttonProps;
    $[5] = color;
    $[6] = size;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ModalOverlay isDismissable={true} className="items-center justify-center overflow-x-hidden p-4 sm:p-8"><Modal isDismissable={true} className="my-auto w-full max-w-6xl min-w-0 border-none shadow-none max-sm:overflow-visible"><Dialog aria-label="Unilytics product demo video" className="relative block w-full min-w-0 border-none p-0 shadow-none"><div className="relative aspect-video w-full min-w-0 overflow-hidden rounded-xl bg-black"><DemoMuxPlayer /><CloseButton slot="close" theme="dark" size="md" className="absolute top-3 right-3 z-10 rounded-full bg-gray-900/90 backdrop-blur-sm hover:bg-black" /></div></Dialog></Modal></ModalOverlay>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = <DialogTrigger>{t3}{t4}</DialogTrigger>;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}